'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

import { LOCAL_STORAGE_TOKEN } from 'src/config-global';

export default function ErrorHandler() {
  const router = useRouter();

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const handleErrorEvent = (event: ErrorEvent) => {
      if (
        event.message &&
        ((event.message.includes('401') && event.message.includes('status code')) ||
          (event.message.includes('Unauthorized') && event.message.includes('AxiosError')))
      ) {
        console.warn('Erro de autenticação detectado. Redirecionando para login...');
        localStorage.removeItem(LOCAL_STORAGE_TOKEN);
        router.push('/login');
      }

      if (
        event.message &&
        (event.message.includes('Loading chunk') || event.message.includes('Loading CSS chunk')) &&
        event.message.includes('failed')
      ) {
        console.warn('Erro ao carregar recurso. Tentando recarregar...');
        window.location.reload();
      }
    };

    window.addEventListener('error', handleErrorEvent);

    // eslint-disable-next-line consistent-return
    return () => {
      window.removeEventListener('error', handleErrorEvent);
    };
  }, [router]);

  return null;
}
